<div class="wrapper" cdkDropListGroup>
    <div class="header">
        <button [mat-menu-trigger-for]="addMenu" mat-icon-button class="add-button" [disabled]="!editable">
            <mat-icon>add</mat-icon>
        </button>
        <span class="operator">{{operator.toUpperCase()}}</span>
        <button class="change-op" mat-icon-button (click)="switchOperator()" matTooltip="Change Operator"
                [disabled]="!editable">
            <mat-icon>find_replace</mat-icon>
        </button>
        <span class="spacer"></span>
        <button mat-icon-button class="remove-button" (click)="removeMe()" [disabled]="!editable">
            <mat-icon>delete_outline</mat-icon>
        </button>
    </div>
    <mat-menu #addMenu="matMenu">
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add()">Condition</button>
        <br>
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add('and', generateId())">AND</button>
        <br>
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add('or', generateId())">OR</button>
    </mat-menu>
    <div class="operands" cdkDropList [cdkDropListEnterPredicate]="canDropPredicate()"
         [cdkDropListConnectedTo]="dropLists()" [id]="myId" (cdkDropListDropped)="reorder($event)"
         [cdkDropListData]="operands">
        <div *ngFor="let operand of operands; let i = index" class="operand" cdkDrag [cdkDragDisabled]="!editable">
            <div class="condition-wrapper" *ngIf="isCondition(operand)">
                <mat-icon cdkDragHandle>drag_indicator</mat-icon>
                <app-condition (remove)="removeOperand(i)" (conditionUpdated)="conditionUpdated(i, $event)"
                               [condition]="operand" [Columns]="columns" [editable]="editable"></app-condition>
            </div>
            <div class="group-wrapper" *ngIf="!isCondition(operand)">
                <mat-icon class="handle" cdkDragHandle>drag_handle</mat-icon>
                <app-group [myId]="operand.myId" (remove)="removeOperand(i)" (newDropList)="childAddedDropList($event)"
                           [parentDropLists]="dropLists()" [Operator]="operand.operator" [Operands]="operand.operands"
                           [columns]="columns" [editable]="editable"></app-group>
            </div>
        </div>
    </div>
</div>
